import { collection, getDocs, query, startAfter, where ,  orderBy,limit} from "firebase/firestore";
import { db } from "../../firebase";
import { getLocalStorageItem } from "../localStorage/getLocalStorage";

const GetAllDealsbyStatus = async (status,type,uid,lastSnapshot,Limit=4) => {


  try {
    const dealsCollection = collection(db, "deals");

  
    //  let q = query(
    //     dealsCollection,
    //     where("bid", "==", getLocalStorageItem("bid")),
    //     where("currentstatus","==",status),
    //     // (getLocalStorageItem("role") === "admin") &&  where("createdBy","==",uid),
    //     orderBy("createdAt","desc"),
    //     // startAfter(lastSnapshot),
    //     limit(Limit),
     
       
    //   );
    let q
if((getLocalStorageItem("role") === "admin")){
  if(type==="*"){
    q = query(
      dealsCollection,
      where("bid", "==", getLocalStorageItem("bid")),
      
      where("currentstatus","==",status),
  
      orderBy("createdAt","desc"),   
      startAfter(lastSnapshot),
      limit(Limit),
    );
  }else{
    q = query(
      dealsCollection,
      where("bid", "==", getLocalStorageItem("bid")),
      
      where("currentstatus","==",status),
    where("interest","==",type),
      orderBy("createdAt","desc"),   
      startAfter(lastSnapshot),
      limit(Limit),
    );
  }

}else{
  if(type==="*"){
    q = query(
      dealsCollection,
      where("bid", "==", getLocalStorageItem("bid")),
      where("createdBy","==",uid),     
      where("currentstatus","==",status),
    // where("interest","==",type),
      orderBy("createdAt","desc"),   
      startAfter(lastSnapshot),
      limit(Limit),)
  }else{
    q = query(
      dealsCollection,
      where("bid", "==", getLocalStorageItem("bid")),
      where("createdBy","==",uid),     
      where("currentstatus","==",status),
    where("interest","==",type),
      orderBy("createdAt","desc"),   
      startAfter(lastSnapshot),
      limit(Limit),)
  }
  // q = query(
  //   dealsCollection,
  //   where("bid", "==", getLocalStorageItem("bid")),
  //   where("createdBy","==",uid),     
  //   where("currentstatus","==",status),
  // where("interest","==",type),
  //   orderBy("createdAt","desc"),   
  //   startAfter(lastSnapshot),
  //   limit(Limit),)
}

      // const querySnapshot = await getDocs(q);
      // querySnapshot.forEach((doc) => {
      //   // doc.data() is never undefined for query doc snapshots
      //   console.log(doc.id, " => ", doc.data());
      // });
  
    const dealSnapshot =await getDocs(q);
    // const dealsData = [];
   
  return dealSnapshot.docs.map((deal) =>
  { return ({ id: deal.id,doc:deal, ...deal.data() })}
  )




// const dealsData=[];
//   const dealSnapshot=getDocs(q);
//  return dealSnapshot.then((deals)=>{
//   deals.forEach((doc)=>{
//     dealsData.push({ id: doc.id, ...doc.data() })
//   })
//   return dealsData
//   })
 


   
 
  } catch (error) {
    console.log(error);
  }
};

export default GetAllDealsbyStatus;